import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NoResults from "@Shared/components/general/no-results.vue";
import ReferrerLinkedAppsLoader from "./referrer-loader/referrer-linked-apps-loader.vue";
import { mapActions } from "vuex";
import { LOAD_REFERRER_LINKED_APPS } from "@Broker/@Modules/clients/referrers/store/referrer-actions";
import CollapsibleCard from "@Broker/@Modules/clients/board/client-profile/components/shared/collapsible-card.vue";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import tinycolor from "tinycolor2";
import { isEmpty, trim } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerLinkedApps",
  filters: {
    getSecondaryComplement() {
      const bodyStyles = window.getComputedStyle(document.body);
      const secondaryColor = trim(bodyStyles.getPropertyValue("--secondary"));
      if (secondaryColor === "#694ed6") {
        return "#694ed6";
      } else return tinycolor(secondaryColor).complement().toHexString();
    }
  },
  components: {
    NoResults,
    ReferrerLinkedAppsLoader,
    CollapsibleCard,
    ProfileAvatar
  },
  props: {
    referrerId: {
      type: [String, Number],
      required: true
    },
    applications: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: true
    };
  },
  computed: {
    isEmpty() {
      return isEmpty(this.applications);
    }
  },
  activated() {
    this.loadLinkedApps();
  },
  mounted() {
    this.loadLinkedApps();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ReferrerStore", [LOAD_REFERRER_LINKED_APPS])), {}, {
    getApplicationLink(clientUsername, agentUsername, applicationId) {
      return {
        name: "application",
        params: {
          clientUsername,
          agentUsername,
          applicationId
        }
      };
    },
    async loadLinkedApps() {
      this.loading = true;
      await this.LOAD_REFERRER_LINKED_APPS({
        referrerId: this.referrerId
      });
      this.loading = false;
    },
    statusText(applicationStatus) {
      return this.$t(`application.status.${applicationStatus}`);
    },
    applicationTypeText(applicationType) {
      return this.$t(`application-flow.flows.${applicationType}`);
    }
  })
});